import React from 'react';
import { Wallet, TrendingUp, PiggyBank, Percent } from 'lucide-react';
import { colors, fmt } from '../utils/theme';
import { StatCard } from './UI';
import useIsMobile from '../hooks/useIsMobile';

// Quadros de Limite total, Utilizado, Disponível e % de uso (02/11/2026) — os
// mesmos em Cartões (por cartão) e Titulares (consolidado por titular). Quem
// usa passa as linhas que estão na tela: os totais acompanham filtro e busca.
// No cartão conectado ao Open Finance entram o limite e o disponível do banco.
export const somaDe = (linhas, campo) => linhas.reduce((s, l) => s + (Number(l[campo]) || 0), 0);

export default function TotaisDeLimite({ limite, utilizado, disponivel, subtitulo }) {
  const pct = limite > 0 ? (utilizado / limite) * 100 : 0;
  const corPct = pct >= 90 ? colors.danger : pct >= 70 ? colors.warning : colors.success;
  const mobile = useIsMobile();
  return (
    <div style={{ display: 'grid', gridTemplateColumns: mobile ? 'repeat(2, minmax(0, 1fr))' : 'repeat(auto-fit, minmax(240px, 1fr))', gap: mobile ? 10 : 12, marginBottom: 16 }}>
      <StatCard label="Limite total" value={fmt(limite)} icon={Wallet} subtitle={subtitulo} />
      <StatCard label="Utilizado" value={fmt(utilizado)} color={colors.danger} icon={TrendingUp} />
      <StatCard label="Disponível" value={fmt(disponivel)} color={colors.success} icon={PiggyBank} />
      <StatCard label="% de uso" value={`${pct.toFixed(1)}%`} color={corPct} icon={Percent} />
    </div>
  );
}
